import Route from '@ember/routing/route';

export default class FansRoute extends Route {}
